<template>
    <div class="store-cards">
        <div class="store-cards__header">
            <span style="font-size: 14px">{{ $t('views.inventory.subtitle') }}</span>
            <button v-if="isVisible" class="btn btn-link p-0" @click="toggleCollapse" style="color: inherit; line-height: 1">
                <i class="fa fa-chevron-up" style="font-size: 11px"></i>
            </button>
            <button v-else class="btn btn-link p-0" @click="toggleCollapse" style="color: inherit; line-height: 1">
                <i class="fa fa-chevron-down" style="font-size: 11px"></i>
            </button>
        </div>
        <div v-if="isVisible" class="store-cards__list">
            <div
                v-for="(n, i) in [-2, -1, -3]"
                :key="i"
                style="position: relative"
                :class="[n === -1 ? 'bg-soft-danger text-danger' : n === -2 ? 'bg-soft-success text-success' : 'bg-soft-primary text-primary', { selected: selectedFilterCard.id === n }, filterCardClass(n)]"
                @click="getFilterCard(n)"
            >
                <strong>({{ numberFormat(filterSorted[i]?.product_count) }})</strong>
                <span>{{ $t(`views.inventory.filters.${n === -1 ? 'inActiveProducts' : n === -2 ? 'activeProducts' : 'noCostProducts'}.label`) }}</span>
                <button v-if="selectedFilterCard.id === n" class="remove-btn btn btn-link">
                    <i class="bi-x-lg" style="font-size: 10px"></i>
                </button>
            </div>

            <draggable v-model="filterSorted" class="store-cards__list draggable" v-bind="{ ghostClass: 'ghost' }" item-key="id">
                <template #item="{ element }">
                    <template v-if="![-1, -2, -3].includes(element.id)">
                        <div style="position: relative" :class="[{ selected: element.id === selectedFilterCard.id }, filterCardClass(element.id)]" @click="getFilterCard(element.id)">
                            <strong>({{ numberFormat(element.product_count) }})</strong>
                            <span>{{ element.filter_name }}</span>
                            <button v-if="selectedFilterCard.id === element.id" class="remove-btn btn btn-link">
                                <i class="bi-x-lg" style="font-size: 10px"></i>
                            </button>
                        </div>
                    </template>
                </template>
            </draggable>
            <button class="add btn bg-white btn-sm" @click="visibleNewFilter = true">
                <i class="fa fa-plus" style="font-size: 14px"></i> <span>{{ $t('views.inventory.addNewFilter') }}</span>
            </button>
        </div>
    </div>
    <NewFilter v-model="visibleNewFilter" />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import draggable from 'vuedraggable'
import NewFilter from './modals/NewFilter.vue'

export default {
    name: 'InventoryFilterCards',
    props: {
        modelValue: {
            type: Boolean,
            default: true,
        },
    },
    components: { draggable, NewFilter },
    data() {
        return {
            visibleNewFilter: false,
            isVisible: true,
        }
    },
    computed: {
        ...mapState('inventory', ['filters', 'selectedFilterCard']),
        filterSorted: {
            get() {
                return [...this.filters]
            },
            set(value) {
                this.filterSort(value)
            },
        },
    },
    mounted() {
        const savedState = localStorage.getItem('inventory.filtercards')
        this.isVisible = savedState ? JSON.parse(savedState) : true
        this.createObserver()
    },
    methods: {
        ...mapActions('inventory', ['getFilter', 'getInventoryList', 'updateFilter', 'filterSort']),
        ...mapMutations('inventory', ['SET_FILTER_PARAMS', 'SET_SELECTED_FILTER_CARD', 'SET_RESET_FILTER_OPTIONS', 'SET_RESET_SELECTED_FILTER_CARD']),
        toggleCollapse() {
            this.isVisible = !this.isVisible
            localStorage.setItem('inventory.filtercards', JSON.stringify(this.isVisible))
        },
        numberFormat(number) {
            return new Intl.NumberFormat('tr-TR').format(number)
        },
        getFilterCard(id) {
            if (this.selectedFilterCard.id === id) {
                this.SET_RESET_SELECTED_FILTER_CARD()
            } else {
                this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
                this.SET_FILTER_PARAMS({ key: 'filter_id', value: id })
                this.SET_SELECTED_FILTER_CARD({ id })

                if ([-1, -2, -3].includes(id)) {
                    this.SET_RESET_FILTER_OPTIONS()
                } else {
                    this.getFilter(id)
                }
            }
            this.getInventoryList()
        },
        createObserver() {
            const draggableIsScrollable = document.querySelector('.draggable')
            if (!draggableIsScrollable) return
            const observer = new ResizeObserver(() => {
                if (draggableIsScrollable && draggableIsScrollable.scrollWidth > draggableIsScrollable.clientWidth) {
                    document.querySelector('.draggable').style.marginTop = '3px'
                }
            })
            observer.observe(draggableIsScrollable)
        },
        filterCardClass(id) {
            if (id === -1) return 'inactive-products'
            if (id === -2) return 'active-products'
            if (id === -3) return 'without-costs-products'
            return 'standard-products'
        },
    },
}
</script>

<style lang="scss" scoped>
.store-cards {
    display: flex;
    flex-direction: column;

    &__header {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #677788;
        margin-bottom: 5px;
    }

    &__list {
        display: inline-flex;
        align-items: center;
        flex-wrap: nowrap;
        border-radius: 8px;
        padding: 6px 0;
        overflow-x: auto;
        white-space: nowrap;
        gap: 5px;
        height: 60px;
        overflow: hidden;

        &.draggable {
            max-width: 100%;
            overflow-x: auto;
            box-shadow: none !important;
            background-color: transparent !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        &::-webkit-scrollbar {
            height: 4px;
        }

        ::-webkit-scrollbar-thumb {
            background: #e7eaf3b3;
            border-radius: 0;
        }

        > div {
            color: #677788;
            font-size: 13px;
            display: flex;
            gap: 5px;
            cursor: pointer;
            align-items: center;
            padding: 6px 12px !important;
            margin: 0 2.5px !important;
            transition: all 0.2s ease-in-out;
            border: 2px solid transparent;
            border-radius: 8px;
            background-color: var(--inventory-gray);
            border: 1px solid transparent;

            &.selected {
                background-color: #fff;
                height: 35.5px;
                border-radius: 8px;
                margin-top: 10px !important;
                z-index: 1;

                .remove-btn {
                    line-height: 1;
                    position: absolute;
                    top: -10px;
                    right: -2.5px;
                    background-color: rgba(39, 46, 62, 60%);
                    border-radius: 50%;
                    color: #fff;
                    padding: 2.5px;
                    width: 18px;
                    height: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                &.active-products {
                    border: 1px solid rgb(0, 201, 167);
                }
                &.inactive-products {
                    border: 1px solid rgb(237, 76, 120);
                }
                &.without-costs-products {
                    border: 1px solid rgb(255, 160, 30);
                }
                &.standard-products {
                    border: 1px solid rgb(39, 46, 62);
                }
            }

            &:hover {
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 0px 3px 6px 0px #8c98a440;
            }
        }

        button.add {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 8px 16px;
            border-radius: 8px;
            border: 1px solid #e7eaf3;

            &:hover {
                background-color: #677788 !important;
                color: #fff;
            }
        }
    }
}

.ghost {
    border: 2px dashed #8c98a4 !important;
    border-radius: 8px;
}
</style>
